import { z } from "zod";
export const DTOPageHistoryVersionReason = z.enum([
    "Manual",
    "Publish",
    "Restore",
]);
export const DTOPageHistoryVersion = z.object({
    id: z.string(),
    createdAt: z.string(),
    createdByUserId: z.string().nullable(),
    /** Null = Liveblocks auto-snapshot */
    reason: DTOPageHistoryVersionReason.nullable(),
    /** User-provided label for a manual snapshot. Null for auto/publish/restore. */
    name: z.string().nullable(),
    restoredFromVersionId: z.string().nullish(),
    authors: z.array(z.string()),
    publishedAt: z.string().nullish(),
    publishedByUserId: z.string().nullish(),
});
export const DTOPageHistoryVersionListResponse = z.object({
    pageHistoryVersions: z.array(DTOPageHistoryVersion),
});
export const DTOPageHistoryVersionContentFormat = z.enum(["json", "yjs"]);
export const DTOPageHistoryVersionContent = z
    .object({
    id: z.string(),
    /** Prosemirror JSON — pass directly to `editor.commands.setContent(jsonContent)`. */
    jsonContent: z.custom().optional(),
    /** Base64-encoded Yjs update with full op history + client IDs. */
    yDocContent: z.string().optional(),
})
    .refine((v) => v.jsonContent !== undefined || v.yDocContent !== undefined, {
    message: "At least one of jsonContent or yDocContent must be present",
});
export const DTOPageHistoryVersionCreatePayload = z.object({
    name: z.string().trim().min(1).max(100),
});
export const DTOPageHistoryVersionCreateResponse = z.object({
    pageHistoryVersion: DTOPageHistoryVersion,
});
export const DTOPageHistoryVersionRestoreResponse = z.object({
    pageHistoryVersion: DTOPageHistoryVersion,
});
